import { memo } from "react"
import { Link } from "@tanstack/react-router"
import { IconChevronRightOutline18 as ChevronRight } from "nucleo-ui-outline-18"

export const ThreadQuoteRow = memo(
	({ to, quote, label }: { to: string; quote: string; label: string }) => (
		<Link
			to={to}
			data-testid="agent-thread-quote"
			className="group -mx-3 flex items-baseline gap-4 rounded-lg px-3 py-2.5 text-primary hover:bg-gray-100 dark:hover:bg-gray-800"
		>
			<span className="min-w-0 flex-1 text-[15px] leading-relaxed">{`"${quote}"`}</span>
			<span className="flex flex-none items-center gap-1.5 whitespace-nowrap text-xs text-tertiary group-hover:text-secondary">
				{label}
				<ChevronRight className="h-3.5 w-3.5 flex-none transform-gpu" />
			</span>
		</Link>
	),
)
